import { Box } from '@mui/material'
import React, { ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import SideMenue from '../SideMenue'
import Header from '../Header'
import { useSelector } from 'react-redux'
import { RootState } from '../../Redux/store'

interface MainLayoutProps {
    children: ReactNode;
}

function AdminLayout({ children }: MainLayoutProps) {
    const { userDetails } = useSelector((state: RootState) => state.global)
    const navigate = useNavigate()

    useEffect(() => {
        if (userDetails?.role != "admin") {
            navigate(-1)
        }
    }, [])

    return (
        <Box className='d-flex bg-black overflow-hidden gap-0 w-100' sx={{height:'100dvh'}}>
            <SideMenue />
            <Box sx={{ flex: 1, overflowX: 'hidden !important'}} className='d-flex h-100 overflow-hidden  flex-column'>
                <Box className='position-sticky top-0 w-100' sx={{ zIndex: 3 }}>
                    <Header />
                </Box>
                <Box className='bg-black overflow-auto' sx={{flex:1, bgcolor:"rgb(250,250,253)"}} >
                    {children}
                </Box>
            </Box>
        </Box>
    )
}

export default AdminLayout
